import axios from "../../../api/axios";

export const EMPTY_SIGNER = {
  user_id: null,
  employee_id: null,
  employee_label: "",
  name: "",
  title: "",
  label: "",
  national_identity_number: "",
  email: "",
  mobile: "",
};

export function normalizeSigners(signers) {
  if (!Array.isArray(signers) || signers.length === 0) return [{ ...EMPTY_SIGNER }];
  return signers.map((s) => ({
    user_id: s?.user_id ?? null,
    employee_id: s?.employee_id ?? null,
    employee_label: s?.employee_label || "",
    name: s?.name || "",
    title: s?.title || "",
    label: s?.label || "",
    national_identity_number: s?.national_identity_number || "",
    email: s?.email || "",
    mobile: s?.mobile || "",
  }));
}

export function serializeSigners(signers) {
  return (signers || [])
    .map((s) => {
      const entry = {
        user_id: s.user_id || undefined,
        employee_id: s.employee_id || undefined,
        employee_label: s.employee_label?.trim() || undefined,
        name: s.name?.trim() || undefined,
        title: s.title?.trim() || undefined,
        label: s.label?.trim() || undefined,
        email: s.email?.trim() || undefined,
        mobile: s.mobile?.trim() || undefined,
      };
      if (!s.employee_id && s.national_identity_number?.trim()) {
        entry.national_identity_number = s.national_identity_number.trim();
      }
      return Object.fromEntries(Object.entries(entry).filter(([, v]) => v != null && v !== ""));
    })
    .filter(
      (s) =>
        s.user_id ||
        s.employee_id ||
        s.name ||
        s.title ||
        s.label ||
        s.national_identity_number ||
        s.email ||
        s.mobile
    );
}

export function hasConfiguredSigners(signers) {
  return serializeSigners(signers).length > 0;
}

export function signerReadyForPosten(signer) {
  if (!signer) return false;
  if (signer.employee_id) return Boolean(signer.name?.trim() || signer.employee_label?.trim());
  if (signer.national_identity_number?.trim()) return Boolean(signer.name?.trim());
  return Boolean(signer.name?.trim() && signer.email?.trim() && signer.mobile?.trim());
}

export function mapSignersForPosten(signers) {
  return serializeSigners(signers).map((s) => ({
    name: s.name || s.employee_label,
    title: s.title,
    email: s.email,
    mobile: s.mobile,
    national_identity_number: s.national_identity_number,
    employee_id: s.employee_id,
    user_id: s.user_id,
  }));
}

export async function fetchEmployeeSignerProfile(userId) {
  const userRes = await axios.get(`/users/${userId}`, {
    params: {
      fields: "id,displayTitle,email,mobile,mobile_work,working_posistion,employment",
    },
  });
  const user = userRes.data;
  const employmentId = user?.employment?.id;
  let employee = null;

  if (employmentId) {
    const empRes = await axios.get(`/users/${userId}/employees/${employmentId}`, {
      params: { fields: "id,social_security,name,email,mobile,phone,working_posistion" },
    });
    employee = empRes.data;
  }

  return {
    user_id: user?.id ?? null,
    employee_id: employee?.id ?? null,
    employee_label: user?.displayTitle || employee?.name || "",
    name: user?.displayTitle || employee?.name || "",
    title: employee?.working_posistion || user?.working_posistion || "",
    email: employee?.email || user?.email || "",
    mobile: employee?.mobile || employee?.phone || user?.mobile_work || user?.mobile || "",
    national_identity_number: employee?.social_security || "",
  };
}
